@use 'sass:math';
@import '@a-ui/core/src/styles/quarks/_quarks.functions';
@import '@a-ui/core/src/styles/quarks/_quarks.mixins';
@import '@a-ui/core/src/styles/quarks/_quarks.variables';

.m-overlay__inner {
  width: 100%;
  max-width: calc(var(--SPACER) * 25);
}

.m-cookie-consent {

  .m-modal__footer {
    flex-wrap: wrap;
    gap: var(--SPACER-XS);

    .a-button:not(:first-child) {
      white-space: nowrap;

      @include at($screen-xs) {
        margin-left: 0;
      }
    }
  }
}

.m-cookie-consent__category-title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--SPACER);
  justify-content: space-between;
  width: 100%;

  h2 {
    cursor: pointer;
  }

  .u-text-right p {
    align-items: center;
    display: flex;
    min-height: 1.75rem;
  }

  .a-switch__button {
    margin-right: var(--SPACER);

    &:before {
      left: calc(100% - var(--SPACER));
    }

    &:after {
      left: 100%;
    }
  }
}

.m-cookie-consent__category-detail {
  overflow: hidden;
  padding-left: var(--SPACER);

  .a-table-responsive-wrapper table {
    >tbody>tr>td,
    >tfoot>tr>td,
    >thead>tr>td {
      display: table-cell;
      vertical-align: top;
      white-space: pre-wrap;
    }

    td {
      -webkit-hyphens: auto;
      hyphens: auto;

      &:before {
        content: '';
        display: block;
      }

      &:nth-of-type(4):before {
        min-width: 12rem;
      }
    }
  }

  tr.is-condensed {
    height: var(--SPACER-L);
  }
}

.m-cookie-consent--non-blocking {
  background: #fff;
  border-top: 1px solid var(--BORDER-COLOR);
  bottom: 0;
  box-shadow: 0 calc(-1 * var(--SPACER)) 0 var(--BOX-SHADOW-COLOR);
  max-height: 50vh;
  overflow: auto;
  position: fixed;
  width: 100%;
  z-index: layer('overlay');
}

.m-cookie-consent__content {
  @include at($screen-md) {
    display: flex;
    gap: var(--SPACER);
  }
}

.m-modal__top-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: var(--SPACER-XS);
  justify-content: space-between;
}

.m-cookie-consent__text {
  padding-bottom: var(--SPACER);
}

.m-cookie-consent__buttons {
  display: flex;
  flex-wrap: wrap;
  white-space: nowrap;
  gap: var(--SPACER-XS);

  @include at($screen-md) {
    flex-direction: column;
    justify-content: flex-end;
  }
}
